module.exports = __webpack_public_path__ + "static/img/bg2.b472c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/bg2.png
// module id = 8Cg7
// module chunks = 70